import { render, staticRenderFns } from "./examen-bio.html?vue&type=template&id=4c962c4e&scoped=true&external"
import script from "./examen-bio.js?vue&type=script&lang=js&external"
export * from "./examen-bio.js?vue&type=script&lang=js&external"
import style0 from "./examen-bio.scss?vue&type=style&index=0&id=4c962c4e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c962c4e",
  null
  
)

export default component.exports